export class WebhookV1StandardPayloadBackupVault {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupVaultTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupVaultArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupVault.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupVaultTypeEnum;
(function (WebhookV1StandardPayloadBackupVaultTypeEnum) {
    WebhookV1StandardPayloadBackupVaultTypeEnum["Created"] = "BACKUP_VAULT_CREATED";
    WebhookV1StandardPayloadBackupVaultTypeEnum["Deleted"] = "BACKUP_VAULT_DELETED";
})(WebhookV1StandardPayloadBackupVaultTypeEnum || (WebhookV1StandardPayloadBackupVaultTypeEnum = {}));
